export default __webpack_public_path__ + "static/media/ardent.3684220f.png";